const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "122.88px",
    height: "122.881px",
    viewBox: "0 0 122.88 122.881",
    enableBackground: "new 0 0 122.88 122.881",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.76316, 0, 0, 0.76316, 14.539715, 12.23651)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.927 15.113 L 81.854 15.113 L 70.109 81.854 L 52.679 81.854 L 40.927 15.113 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -73.292,
    y: -113.835,
    width: 23.705,
    height: 23.705,
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(-1, 0, 0, -1, 0, 0)"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 7,
      fill: "none",
      stroke: "rgb(255, 255, 255)"
    },
    cx: 61.44,
    cy: 61.44,
    r: 54.857
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.be6b1a5dc15b01853c16b3112a0d589a.svg";
export { ForwardRef as ReactComponent };